<template>
  <div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" width="35%">File</th>
            <th></th>
            <th class="text-left" width="30%"><v-badge dot title="Il valore è modificabile" offset-x="-2" offset-y="4" >Utilizzo immagine</v-badge></th>
            <th class="text-left">Data</th>
            <th class="text-left">Dimensione</th>
            <th class="text-center" width="11%"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(file, i) in files" :key="i">
            <!-- <td>{{file.name}}</td> -->
            <td><a :href="file.pathFile" title="Scarica il file">{{file.name}}</a></td>
            <td>
              <v-img :src="file.pathFile" max-width="50"></v-img>
            </td>
            <td>
              <!-- :return-value.sync="file.description" -->
              <v-edit-dialog :return-value.sync="file.description" large persistent cancel-text="Annulla" save-text="Salva" @save="onSaveDescription(file)">
                <span width="300px">{{ file.description.descrizione }}</span>
                <template v-slot:input>
                  <v-select v-model="utilizzo" class="mt-5" :items="utilizzoImmagini" item-text="descrizione" item-value="codice" label="Utilizzo immagine" return-object></v-select>
                </template>
              </v-edit-dialog>
            </td>            
            <td>{{file.lastModified | date}}</td>
            <td>{{file.size | fileSize}}</td>
            <td>
              <v-icon dense title="Modifica il file" class="mr-2" @click="onEditFile(file)">mdi-pencil</v-icon>
              <v-icon dense title="Cancella il file" @click="onRemoveFile(file)">mdi-delete-outline</v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>    
    <dialog-conferma
      :show="dialogConferma"
      :title="titoloConferma"
      :message="messaggioConferma"
      @dialog-confirm="onConferma"
      @dialog-cancel="dialogConferma=false"
    />
  </div>
</template>

<script>
/*  eslint-disable */
import _ from "lodash";
import DialogConferma from "@/components/dialogConferma";
import configurazioni from "@/services/configurazioniService";

export default {
  components: {
    DialogConferma,
  },
  props: {
    files: Array,
    moduli: Array,
  },
  data(vm) {
    return {
      dialogConferma: false,
      titoloConferma: "",
      messaggioConferma: "",
      onConferma: vm.onRemoveFile,
      itemToDelete: null,
      utilizzoImmagini: [],
      utilizzo: null
    };
  },
  async mounted() {
    const impostazioni = await configurazioni.getConfigurazione("backoffice", "impostazioni")
    this.utilizzoImmagini = _.get(impostazioni, "prodotti.immagini.utilizzo") || [] // ricordarsi di aggiungere nel db in configurazioni/backoffice/impostazioni/prodotti/immagini/utilizzo
  },
  methods: {
    onSaveDescription(file) {
      file.description = _.cloneDeep(this.utilizzo)
      this.$emit("change", file);
    },
    onRemoveFile(item) {
      this.titoloConferma = "Cancellazione file";
      this.messaggioConferma = "Confermi la cancellazione del file ?";
      this.onConferma = this.removeFile;
      this.itemToDelete = item;
      this.dialogConferma = true;
    },
    async removeFile() {
      const item = this.itemToDelete;
      this.$emit("delete", item);
      this.itemToDelete = null;
      this.dialogConferma = false;
    },
    onEditFile(item) {
      this.$emit("edit", item);
    }
  }
};
</script>
